import { render, staticRenderFns } from "./SubProductVariant.vue?vue&type=template&id=21c3a2a8&"
import script from "./SubProductVariant.vue?vue&type=script&lang=js&"
export * from "./SubProductVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports